import {CompanyGroupPortalRoleModel} from "../redux/types";
import {useAppSelector} from "../redux/hooks";
import {hasAnyRequiredCompanyGroupPolicy} from "../util/role";

interface Props {
  children: any
  policy: keyof CompanyGroupPortalRoleModel | (keyof CompanyGroupPortalRoleModel)[]
}

export const RenderForCompanyGroupPolicy = ({children, policy}: Props) => {
  const authenticatedUser = useAppSelector(state => state.auth.authenticatedUser)
  const currentCompanyGroupId = useAppSelector(state => state.auth.currentCompanyGroupId)

  const policies = Array.isArray(policy) ? policy : [policy];

  if (!hasAnyRequiredCompanyGroupPolicy(authenticatedUser, currentCompanyGroupId, ...policies)) {
    return null
  }

  return children
}
